'use client'
import { Cell } from 'recharts';

interface PieSliceProps {
	fill: string;
}

export const PieSlice = ({ fill }: PieSliceProps) => {
	return <Cell fill={fill} />;
};
